import { ERROR } from 'components/error-handle/actions';

/**
 * @param state
 * @param {errorHandleAction} action
 * @return {*}
 */
export const errorHandleReducer = (
  state = {
    errorMessage: null,
    errorStatus: null,
    errorType: null,
  },
  action
) => {
  switch (action.type) {
    case ERROR:
      const { message, status, type } = action.payload;
      return {
        ...state,
        errorMessage: message,
        errorStatus: status,
        errorType: type,
      };

    default:
      return state;
  }
};
